import { directive as onClickaway } from "vue-clickaway";
import { getProductPriceTitle } from "@/helpers";
import { mapGetters } from "vuex";

export default {
  directives: {
    onClickaway: onClickaway,
  },
  props: {
    type: {
      type: String,
      default: "objectData",
    },
    value: {},
    label: {
      type: String,
      default: "",
    },
    progress: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    itemValue: {
      type: String,
      default: "default",
    },
    itemTitle: {
      type: String,
      default: "count",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      resetItem: false,
      page: 0,
      openSelect: false,
      selectedItem: this.value,
      selectedFilters: {
        category: "",
        type: {
          name: "toDefault",
          key: "default",
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "auth/isAuthenticated",
      isDistributor: "profile/isDistributor",
      isProfessional: "profile/isProfessional",
    }),
    sortedList() {
      const list = [...this.list];
      let sortedList = list.sort((a, b) => b.value - a.value);
      sortedList = sortedList.sort((a, b) => {
        // if (this.isAuthenticated && (!this.isProfessional || !this.isDistributor)) {
        if (a.isRefill && !b.isRefill) return 1;
        if (!a.isRefill && b.isRefill) return -1;
        if (a.outletReasons?.data?.length && !b.outletReasons?.data?.length) return 1;
        if (!a.outletReasons?.data?.length && b.outletReasons?.data?.length) return -1;
        // }

        return a.value - b.value;
      });
      return sortedList;
    },
  },
  created() {
    this.selectedItem = this.value;
  },
  methods: {
    getProductPriceTitle,
    getOptionTitle(item) {
      if (item.outletReasons?.data?.length) {
        return `${item[this.itemTitle]} - outlet`
      } else if (item.isRefill) {
        return `${item.title} - refill`
      }
      if (this.itemTitle !== "value") {
        return item[this.itemTitle];
      }

      return this.getProductPriceTitle(item);
    },
    changeSelect(item) {
      if (this.$route.query.hasOwnProperty("id")) this.$router.replace({ name: "catalog", query: "" });

      this.resetItem = false;
      setTimeout(() => {
        this.openSelect = false;
      }, 1);

      this.selectedItem = item;
      this.$emit("input", item);
    },
    away: function () {
      this.openSelect = false;
    },
  },
};
